import './on-boarding-modal.css';
import { h } from 'preact';

import CloseButton from '../CloseButton';

export default function OnBoardingModal({ children, isOpen, onClose }) {
	return (
		<div aria-hidden={!isOpen} className={`on-boarding-modal-container${isOpen ? ' is-open' : ''}`}>
			<div className="on-boarding-modal-body">
				{children}
			</div>
			{typeof onClose === 'function' && <CloseButton onClickHandler={onClose} theme="dark" />}
		</div>
	);
}
